import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { MultiSelectDynamic } from 'core-components/library/multiSelect'
import { CrudStore } from 'core/types/crudStore'

interface IProps {
  onChange: (value: string[]) => void
  value: string[]
  className?: string
}

export const ManagerMiltiselect = ({ onChange, value, className }: IProps) => {
  const crud = CrudStore.get(CrudStoreItemPartner360.JBPManagers)

  const handleChange = (value: string[]) => {
    onChange(value)
  }

  return (
    <MultiSelectDynamic
      fieldsToSearch={['Email', 'FirstName', 'LastName']}
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      value={value}
      source={crud}
      label="Manager"
      caption={'Email'}
      onChange={handleChange}
    />
  )
}
